<div class="toolbar">
  <button matButton="text" class="toolbarButton" (click)="addLoop()">Add Loop</button>
  <button matButton="text" class="toolbarButton" [disabled]="(selectedLoop?.id || 0) === 0" (click)="copyLoop()">Copy Loop
  </button>
  <button matButton="text" class="toolbarButton" [disabled]="(selectedLoop?.id || 0) === 0" (click)="deleteLoop()">Delete
    Loop
  </button>
  <span class="spacer"></span>
  @if (showCreateScheduleButton()) {
    <button matButton="text" class="toolbarButton" [disabled]="(loops()?.length || 0) === 0"
      (click)="addToSchedule()">Create Schedule
    </button>
  }
</div>
@if (errorMessage()) {
  <div class="errorMessage">
    {{ errorMessage() }}
  </div>
}
<div class="content">
  @if ((loops()?.length || 0) > 0) {
    <div class="listWrapper">
      <mat-list class="loopList">
        @for (loop of loops(); track loop) {
          <mat-list-item class="sureflowListItem"
            [class.selected]="isSelected(loop)">
            @if (!loop.isEditMode) {
              <span class="listItemLabel" (click)="selectLoop(loop)">
                <label class="loopDescriptionLabel">{{ loop.description }}</label>
                <mat-icon class="size-16"
                (click)="loop.isEditMode = true; newLoopDescription = loop.description">edit</mat-icon>
              </span>
            }
            @if (loop.isEditMode) {
              <span class="listItemLabel">
                <input class="loopDescriptionInput" (keyup.enter)="saveLoopDescription(loop)"
                  [(ngModel)]="newLoopDescription"/>
                <mat-icon color="warn" class="size-16 cancelButton" (click)="cancelLoopUpdate(loop)">cancel</mat-icon>
                <mat-icon color="primary" class="size-16" (click)="saveLoopDescription(loop)">done</mat-icon>
              </span>
            }
          </mat-list-item>
        }
      </mat-list>
    </div>
  }
  @if (selectedLoop) {
    <div class="loopDetail">
      <app-sureflow-loop-detail [loopDetail]="selectedLoop" [units]="units()" [systemType]="getSelectedSystemType()"
        [invalidUnitIds]="invalidUnitIds()"
        [selectedUnitIds]="selectedUnitIds()" (addUnit)="addUnitToLoop($event)"
        (editUnits)="editUnits()" (deleteUnits)="deleteUnits()"
        (copyUnits)="copyLoopUnits()" (addNonSureFlowUnit)="addNonSFUnit($event)"
        (selectedUnitsChanged)="unitSelectionChange($event)"
        (recalculate)="recalculateLoop($event)" (autoSelect)="autoSelectUnits($event)"
        (unitsRearranged)="rearrangeUnits($event)">
      </app-sureflow-loop-detail>
    </div>
  }
</div>
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
